import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import type { RetorikActivity } from '../../../models/activityTypes'
import DisplayStandard from './DisplayStandard'
import { TextFrom } from '../../../models/enums'
import TextBubble from './TextBubble'

interface ConversationDisplayProps {
  userQuestion: RetorikActivity | undefined
  botResponses?: Array<RetorikActivity>
  isMobile?: boolean
  triggerScroll: () => void
  canBeStreaming: boolean
}

const ConversationDisplay = ({ userQuestion, botResponses, isMobile, triggerScroll, canBeStreaming }: ConversationDisplayProps): JSX.Element => {
  const isLandscape = useSelector((state: RootState) => state.viewReducer.isLandscape)
  const isWaitingForResponse = useSelector((state: RootState) => state.retorikReducer.isWaitingForResponse)

  return isLandscape ? (
    <React.Fragment>
      <div id={`retorik-botResponses-${userQuestion?.id}`} className='rf-flex rf-flex-col rf-text-size-auto rf-gap-4 rf-scrollbar-hidden'>
        <DisplayStandard currentQuestionId={userQuestion?.id || 'fake-question-id'} triggerScroll={triggerScroll} activities={botResponses || []} isWaitingForResponse={isWaitingForResponse} />
      </div>

      {userQuestion?.text && <TextBubble from={TextFrom.user} id={userQuestion.id} text={userQuestion.text} triggerScroll={triggerScroll} isEnded={true} />}
    </React.Fragment>
  ) : (
    <React.Fragment>
      {userQuestion?.text && <TextBubble from={TextFrom.user} id={userQuestion.id} text={userQuestion.text} triggerScroll={triggerScroll} isEnded={true} />}

      <div id={`retorik-botResponses-${userQuestion?.id}`} className='rf-flex rf-flex-col rf-text-size-auto rf-gap-4 rf-scrollbar-hidden'>
        <DisplayStandard
          currentQuestionId={userQuestion?.id || 'fake-question-id'}
          triggerScroll={triggerScroll}
          activities={botResponses || []}
          isWaitingForResponse={isWaitingForResponse && (!isMobile || (isMobile && canBeStreaming))}
        />
      </div>
    </React.Fragment>
  )
}

export default ConversationDisplay
